import { isFunction, mergeWith } from '@chakra-ui/utils';
import defaultTheme from '@fluidtruck/theme';
export function extendTheme(overrides) {
  function customizer(sourceThunk, overrideThunk) {
    if (isFunction(sourceThunk)) {
      return function () {
        var sourceValue = sourceThunk(...arguments);
        var overrideValue = isFunction(overrideThunk) ? overrideThunk(...arguments) : overrideThunk;
        return mergeWith({}, sourceValue, overrideValue, customizer);
      };
    } // fallback to default behaviour


    return undefined;
  }

  return mergeWith({}, defaultTheme, overrides, customizer);
}
//# sourceMappingURL=extendTheme.js.map